export const WS_URL =
  process.env.REACT_APP_WS_URL || " wss://" + window.location.host + "/ws"
